import React from 'react';
import pt from 'prop-types';
import Status from 'components/status';

import { getCommentAuthorName, isSuperAdminAuthor } from './utils';

// Who wrote a comment, wherever one is shown: its own card, or the one-line
// summary of a closed review
export default function AppReviewCommentAuthor({ user }) {
  return (
    <>
      <span className="review-comments--comment--name">
        {getCommentAuthorName(user)}
      </span>
      {isSuperAdminAuthor(user) && (
        <Status
          className="review-comments--badge-swell"
          type="primary"
          size="sm"
          dot={false}
        >
          Swell
        </Status>
      )}
    </>
  );
}

AppReviewCommentAuthor.propTypes = {
  user: pt.object,
};
